import React from 'react'
import { ProgressBarContainer, ProgressBarFill, ProgressContent } from './styles'

const ProgressBar = ({ value, total, status, children }) => {
  return (
    <ProgressBarContainer>
      <ProgressBarFill value={value} total={total} status={status} />
      <ProgressContent>
        {children}
      </ProgressContent>
    </ProgressBarContainer>
  )
}

export default ProgressBar
